import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import { LANG_LIST, CURRENCY_LIST, getLangValueByLabel, getCurrencyValueByLabel } from '@/config/const';
import { HeaderItem } from '.';

export const useSettingList = () => {
  const { t } = useTranslation();
  const { account } = useStore();

  const { langObj, setLang, setCurrency } = account;

  return useMemo<HeaderItem[]>(
    () => [
      {
        title: langObj.label,
        children: LANG_LIST.map(item => ({ title: item.label })),
        onClick(item) {
          const value = getLangValueByLabel(item.title);
          if (value) {
            setLang(value, false);
            window.location.reload();
          }
        },
      },
      {
        title: t('header.rate.title'),
        children: CURRENCY_LIST.map(item => ({ title: item.label })),
        onClick(item) {
          const value = getCurrencyValueByLabel(item.title);
          if (value) setCurrency(value);
        },
      },
    ],
    [t, langObj.label, setCurrency, setLang],
  );
};
